import React, { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useAppSelector } from '@store/store';
import CybersourceLoader from '@assets/images/CybersourceSplashLoader.svg';
import { Typography } from '@mui/material';
import FormattedMessage from '@molecules/FormattedMessage';

const PaymentRedirectionalLoader: React.FC = () => {
  const { checkoutDetails, error } = useAppSelector((state) => state.invoice);

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [showErrorMessage, setShowMessage] = useState<boolean>(false);

  useEffect(() => {
    if (checkoutDetails) {
      const form = document.getElementById('checkout_form') as HTMLFormElement;
      setTimeout(() => {
        form.submit();
      }, 300);
    }
  }, [checkoutDetails]);

  useEffect(() => {
    if (error) {
      setErrorMessage(error);
      setShowMessage(true);
    }
  }, [error]);

  return (
    <div className="payment-redirection-loader-container">
      <Snackbar
        open={showErrorMessage}
        autoHideDuration={3000}
        onClose={() => {
          setShowMessage(false);
          setErrorMessage('');
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <div>
          <Alert
            severity={'error'}
            variant="filled"
            onClose={() => {
              setShowMessage(false);
              setErrorMessage('');
            }}
          >
            {errorMessage}
          </Alert>
        </div>
      </Snackbar>
      <div>
        <img src={CybersourceLoader} className="loader-image" alt="Loading..." />
      </div>
      <div className="content-wrap">
        <Typography className="content">
          <FormattedMessage id="PAYMENT.LOADER.CONTENT" />
        </Typography>
        <Typography className="message">
          <FormattedMessage id="PAYMENT.LOADER.MESSAGE" />
        </Typography>
      </div>
      {checkoutDetails && (
        <form id="checkout_form" action={checkoutDetails.submitUrl} method="post">
          {Object.entries(checkoutDetails.formData).map(([key, value]) => (
            <input key={key} type="hidden" name={key} value={value} />
          ))}
        </form>
      )}
    </div>
  );
};

export default PaymentRedirectionalLoader;
